// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","SimilarStrollers__headline":"xz_a bih_vp bih_vh bih_xe bih_rg bih_tr bih_qx"};